import { render, staticRenderFns } from "./PatientDetailsComponent.vue?vue&type=template&id=3f705eb0"
import script from "./PatientDetailsComponent.vue?vue&type=script&lang=js"
export * from "./PatientDetailsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../HCP/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports